
export default (state = {}, { type, payload, meta }) => state
